import React from 'react';
import Icon from '@ant-design/icons';
import { ButtonType, Button } from 'components/Controls/Button';
import { SizeType } from 'antd/lib/config-provider/SizeContext';
import ArrowSimpleRightSvg from './arrowSimpleRight.svg';

type IconButtonProps = {
  size?: SizeType,
  iconSize?: number,
  onClick?: () => void,
};

export const ArrowSimpleRightIcon = (props: any) => <Icon component={ArrowSimpleRightSvg} {...props} />;

export const ArrowSimpleRightButton = ({ size = 'medium', iconSize = 24, ...props }: IconButtonProps) => (
  <Button
    type={ButtonType.OutlineIcon}
    icon={<ArrowSimpleRightIcon width={iconSize} height={iconSize} />}
    size={size}
    {...props}
  />
);
